import { useEffect, useRef, useState } from "react";

// This hook is used to delay the value of a variable for a certain amount of time.
export function useDelayedValue<T>(value: T, delayWhenSet: number, delayWhenUnset: number): T {
  const [delayedValue, setDelayedValue] = useState<T>(value);
  const timeout = useRef<NodeJS.Timeout>();
  useEffect(() => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(
      () => {
        setDelayedValue(value);
      },
      value ? delayWhenSet : delayWhenUnset,
    );
    return () => clearTimeout(timeout.current);
  }, [value, delayWhenSet, delayWhenUnset]);

  return delayedValue;
}
